import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';
import Image from 'ui/Image';
import {FieldTypes} from 'utils/page';
import WithPage from '../WithPage';

// With the exception of logic, the UI of this component is identical to the Tip component so we reuse all the CSS classes

const Acknowledge = ({data, isSelectedAnswerCorrect}) => {
    const {t} = useTranslation();
    const CORRECT_HEADINGS = [
        t('correct.one'),
        t('correct.two'),
        t('correct.three'),
    ];
    const title = isSelectedAnswerCorrect
        ? CORRECT_HEADINGS[Math.floor(Math.random() * 3)]
        : t('responseThanks');
    const textFields = data.getTextFieldsMap();
    const description = textFields.get(FieldTypes.ACKNOWLEDGEMENT);

    return (
        <div className="Tip">
            <div className="Tip-content">
                <Image src="../img/acknowledge.png" alt={title} />
                <h1 className="heading-md">{title}</h1>
                {description && (
                    <div
                        dangerouslySetInnerHTML={{
                            __html: description.getTextValue(),
                        }}
                    />
                )}
            </div>
        </div>
    );
};

Acknowledge.propTypes = {
    data: PropTypes.object.isRequired,
    isSelectedAnswerCorrect: PropTypes.bool.isRequired,
};

export default WithPage(Acknowledge);
